import type { ReactNode } from 'react';

import { QueryProvider } from '@/app/providers/query-provider';

/** Ponto único de composição dos providers globais da aplicação. */
export function AppProviders({ children }: { children: ReactNode }) {
  return <QueryProvider>{children}</QueryProvider>;
}
